import { cn } from '@natu/utils/cn';

interface BeforeAfterItemProps {
  header?: string;
  text?: string;
  color?: 'default' | 'primary';
}

export const BeforeAfterItem = ({ header, text, color }: BeforeAfterItemProps) => (
  <div className="flex-1">
    {header && (
      <p
        className={cn(
          'mb-2 text-4xl font-semibold xl:text-5xl',
          color === 'primary' ? 'text-primary-600' : 'text-naturaily-cascade',
        )}
      >
        {header}
      </p>
    )}
    <p className="text-base text-gray-600">{text}</p>
  </div>
);
